<template>
  <div class="swipe-box-answer matrix-group">
    <answer-render ref="answer" :config="config">
      <div slot="head">
        <answer-swipe-desc-list :config="config" :rules="rules" modelKey="displayTitle">
          <template slot="optionList" slot-scope="{model, index, crtDescIndex}">
            <rate-group-answer
              :config="config"
              :model="model"
              :rules="rules"
              :cvtLang="cvtLang"
              :prop="'descList.'+index+'.value'"
              :answerValidate="answerValidate"
              :crtDescIndex="crtDescIndex"
            ></rate-group-answer>
          </template>
        </answer-swipe-desc-list>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
export default {
  name: 'RateGroupBoxAnswer',
  props: ['config', 'cvtLang'],
  data () {
    return {
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ],
      answerValidate
    }
  },
  components: {},
  watch: {},
  computed: {
  },
  methods: {
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" scoped>
  .matrix-group {
    >>> .an-body {
      display: none;
    }
    >>> .an-head {
      .an-body {
        display: block;
      }
    }
    .answer-container {
      border-bottom: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/editor/RateGroupBox/RateGroupBoxAnswer.vue